import { render, staticRenderFns } from "./VploadImgTwo.vue?vue&type=template&id=0bd80a27&scoped=true"
import script from "./VploadImgTwo.vue?vue&type=script&lang=js"
export * from "./VploadImgTwo.vue?vue&type=script&lang=js"
import style0 from "./VploadImgTwo.vue?vue&type=style&index=0&id=0bd80a27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd80a27",
  null
  
)

export default component.exports